import React from "react";
import {autobind} from "core-decorators";
import {Typography} from "antd";
import {IdcardOutlined} from "@ant-design/icons";
import {RouteComponentProps} from "react-router-dom";
import {inject, observer} from "mobx-react";

import "./Subscription.scss";
import {getPlanName} from "@/shared/plans";
import PageLayout from "@/components/PageLayout/PageLayout";
import Store from "@/stores";
import SubscriptionManagement from "./SubscriptionManagement/SubscriptionManagement";
import SubscriptionPricingTable from "./SubscriptionPricingTable";
import SubscriptionTrial from "./SubscriptionTrial";

export interface ISubscriptionProps extends RouteComponentProps {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class Subscription extends React.Component<ISubscriptionProps> {
  renderDescription() {
    const {session} = this.props.store!;
    if (session.activeSubscription) {
      if (session.activeSubscription.trial) return <SubscriptionTrial />;
      return (
        <span>
          Your subscription is active with the <strong>{getPlanName(session.activeSubscription.plan_id)} plan</strong>.
          <br />
          On this page you can manage the subscription.
        </span>
      );
    } else {
      // new user
      if (session.ensembles.length === 0) return "Thank you for signing up. To continue, please choose a plan.";
      else {
        if (session.hasInactiveSubscriptions)
          return "Your subscription is no longer active. To continue, please choose a plan.";
        else return "You are not subscribed. To continue, please choose a plan.";
      }
    }
  }

  render() {
    const {activeSubscription} = this.props.store!.session;
    return (
      <PageLayout>
        <div className="Subscription">
          <Typography.Title className="title" level={3}>
            <IdcardOutlined className="title-icon" />
            Subscription
          </Typography.Title>
          <Typography.Paragraph className="title-description">{this.renderDescription()}</Typography.Paragraph>
          {activeSubscription && !activeSubscription?.trial ? <SubscriptionManagement /> : <SubscriptionPricingTable />}
        </div>
      </PageLayout>
    );
  }
}
